// Domain restructuring: langFromUrl still returns either 'es' or 'en'
// but this will no longer be used to modify paths, instead we'll use tdaconfig.site.context_url

export default function langFromUrl() {
  var urlString = window.location.pathname;
  var urlSubString = urlString.substring(urlString.indexOf('/') + 1, urlString.length);
  var lang;

  if ('es' === urlSubString.substring(0, urlSubString.indexOf('/'))) {
    lang = 'es';
  } else {
    lang = 'en';
  }
  return lang;
};
